import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const formatLocalDate = (date) => {
  if (!date) return "";
  return `${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate(),
  ).padStart(2, "0")}-${date.getFullYear()}`;
};

const PdfDate = ({ page, inputId, value, onChange, place_holder, onOpen, onClose, isActive }) => {
  const [inputValue, setInputValue] = useState(value || '');
  const datePickerRef = useRef(null);

  // Sync internal state with parent value prop
  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  // Handle closing the datepicker when this field is no longer active
  useEffect(() => {
    if (!isActive && datePickerRef.current) {
      datePickerRef.current.setOpen(false);
    }
  }, [isActive]);

  
  return (
    <div className="pdf-date">
      <DatePicker
        ref={datePickerRef}
        selected={inputValue && inputValue.trim() !== '' ? new Date(inputValue) : null}
        onChange={(date) => {
          const newValue = formatLocalDate(date);
          setInputValue(newValue);
          onChange(page, inputId, newValue);
        }}
        placeholderText={place_holder || "MM-DD-YYYY"}
        className="pdf-date-input"
        onCalendarOpen={onOpen}
        onCalendarClose={onClose}
        dateFormat="MM-dd-yyyy"
        dropdownMode="select"
        showMonthDropdown
        showYearDropdown
        maxDate={new Date()}
        open={isActive}
        openToDate={inputValue && inputValue.trim() !== '' ? new Date(inputValue) : null}
      />
      <span
        className="calendar-icon"
        onClick={() => {
          if (datePickerRef.current) {
            datePickerRef.current.setOpen(true);
          }
        }}
      ></span>
    </div>
  );
};

export default PdfDate;
